import React, { useEffect, useMemo } from 'react';
import { IGetLanguages, IItemForGetShortInfo } from 'types';
import { ISelectOption } from 'components/Select/types';
import { useFetchData } from 'hooks/useFetchData';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { getLanguages } from 'backend/additionalInformation';
import { FormSelectNew } from 'components/Select/FormSelectNew';

interface IProps {
	setCustomerDefaultLanguage: (value: string) => void;
	setFetchedLanguages: (value: IItemForGetShortInfo[]) => void;
}

export const DefaultLanguageSelect: React.FC<IProps> = React.memo(
	({ setCustomerDefaultLanguage, setFetchedLanguages }) => {
		const { response, loading, refetch, responseError } = useFetchData<IGetLanguages, null>(getLanguages);
		const { t } = useTranslation('error');
		const { t: tForm } = useTranslation('form');

		useEffect(() => {
			response && setFetchedLanguages(response.data.languages);
		}, [response]);

		const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectDefaultLanguage') }], [t]);

		const options = useMemo<ISelectOption[]>(
			() =>
				response?.data.languages.map((language) => ({
					id: language.id,
					name: tForm(language.name),
				})) || [],
			[tForm, response],
		);

		return (
			<FormSelectNew
				testId="DefaultLanguageSelect"
				name="IDSelectedCustomerDefaultLanguage"
				label="defaultLanguageLabel"
				options={options}
				fetchError={responseError}
				loading={loading}
				validationRules={validationRules}
				onRefetch={refetch}
				onChange={setCustomerDefaultLanguage}
			/>
		);
	},
);
